import { useSyncExternalStore } from 'react';
import { getUser, subscribe, type AuthUser } from './auth-store.ts';

export function useAuthUser(): AuthUser | null {
  return useSyncExternalStore(subscribe, getUser, () => null);
}
